/**
 * Black Week Discount Auto-Apply
 * Wendet "BLACKWEEK" beim ersten Buy-Button Klick an
 */

(function() {
  'use strict';

  const DISCOUNT_CODE = 'BLACKWEEKEND';
  const SESSION_KEY = 'blackweek_discount_applied';
  
  let isApplyingDiscount = false;

  /**
   * Prüft ob Discount bereits in dieser Session angewendet wurde
   */
  function wasDiscountApplied() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  /**
   * Markiert dass Discount angewendet wurde
   */
  function markDiscountAsApplied() {
    try {
      sessionStorage.setItem(SESSION_KEY, 'true');
    } catch (e) {
      console.warn('Session Storage nicht verfügbar');
    }
  }

  /**
   * Wendet den Discount-Code an
   */
  async function applyDiscount() {
    if (isApplyingDiscount) {
      return;
    }

    isApplyingDiscount = true;

    try {
      console.log('🎯 Wende BLACKWEEK Rabatt an...');
      
      // Discount via URL anwenden
      await fetch(window.Shopify.routes.root + 'discount/' + DISCOUNT_CODE, {
        method: 'GET',
        redirect: 'manual'
      });
      
      // Als angewendet markieren
      markDiscountAsApplied();
      
      console.log('✅ BLACKWEEK Rabatt aktiviert');
      
      // Kurz warten damit Discount gesetzt ist
      await new Promise(resolve => setTimeout(resolve, 300));
      
    } catch (error) {
      console.error('Fehler beim Anwenden des Rabatts:', error);
    } finally {
      isApplyingDiscount = false;
    }
  }

  /**
   * Interceptor für Buy Button Klicks
   */
  function interceptBuyButtons() {
    // Alle Klicks abfangen (capture phase)
    document.addEventListener('click', async function(event) {
      
      // Prüfen ob es ein Submit-Button in einer product-form ist
      const button = event.target.closest('button[type="submit"]');
      
      if (!button) return;
      
      const form = button.closest('form[is="product-form"]');
      
      if (!form) return;
      
      // Wenn Discount bereits angewendet wurde, normal weitermachen
      if (wasDiscountApplied()) {
        return;
      }
      
      // ERSTER Buy-Button Klick in dieser Session!
      event.preventDefault();
      event.stopImmediatePropagation();
      
      console.log('🛒 Erster Add-to-Cart - aktiviere BLACKWEEK Rabatt...');
      
      // Rabatt anwenden
      await applyDiscount();
      
      // Button erneut klicken
      setTimeout(() => {
        button.click();
      }, 100);
      
    }, true); // capture phase = VOR anderen Event Handlers
  }

  /**
   * Interceptor für Form Submits (Fallback)
   */
  function interceptFormSubmits() {
    document.addEventListener('submit', async function(event) {
      const form = event.target;
      
      // Nur product-forms
      if (!form.matches('form[is="product-form"]')) {
        return;
      }
      
      // Wenn bereits angewendet oder gerade am Anwenden
      if (wasDiscountApplied() || event._blackweekProcessed) {
        return;
      }
      
      // ERSTER Submit in dieser Session
      event.preventDefault();
      event.stopImmediatePropagation();
      
      console.log('🛒 Erster Add-to-Cart - aktiviere BLACKWEEK Rabatt...');
      
      // Rabatt anwenden
      await applyDiscount();
      
      // Form erneut submitten
      setTimeout(() => {
        const newEvent = new Event('submit', { bubbles: true, cancelable: true });
        newEvent._blackweekProcessed = true;
        form.dispatchEvent(newEvent);
      }, 100);
      
    }, true); // capture phase
  }

  /**
   * Initialisierung
   */
  function initialize() {
    console.log('🎯 BlackWeek Auto-Discount aktiv - wartet auf ersten Buy-Button Klick');
    
    interceptBuyButtons();
    interceptFormSubmits();
  }

  // Starten
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();
